export default __webpack_public_path__ + "a48f0e6671677fd97e747366eec4a878.png";